import { render, staticRenderFns } from "./policy-layout.component.vue?vue&type=template&id=a0b8012a&scoped=true"
import script from "./policy-layout.component.ts?vue&type=script&lang=ts&external"
export * from "./policy-layout.component.ts?vue&type=script&lang=ts&external"
import style0 from "./policy-layout.component.vue?vue&type=style&index=0&id=a0b8012a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b8012a",
  null
  
)

export default component.exports